import {BreadCrumbs} from "../../../components/open/pages";
import {useEffect, useState} from "react";
import ClickOutsideDetector from "../../../components/clickOutside/click-outside";
import {
    ThickAddIcon,
    ThinCaretDownIcon,
    ThinChevronRight,
    ThinCreditCardTimeIcon,
    ThinPasswordIcon,
    ThinTimeIcon,
    TomansIcon
} from "../../../components/icons/material-icons";
import {Calendar, DayRange} from "@hassanmojab/react-modern-calendar-datepicker";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian, PersianToGregorian} from "../../../components/techaran/date-convert";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {pointTransactionPayMethodToString, pointTransactionSourceToString} from "../../admins/students/details";
import {ParentsMaxPayPerDayEditModal} from "./max-pay-modal";
import {StudentsSetCardPasswordModal} from "./set-pass";
import {StudentsIncreaseStoreBudgetModal} from "./increase-budget";
import {ShowSnackbar} from "../../../components/template/snackbar";

interface pointTransactionSingleInterface {
    id: number,
    isSale: 0 | 1,
    price: number,
    source: 'device' | 'operator' | 'online' | 'station',
    method: 'online' | 'cash' | 'credit',
    createdAt: string,
}

export const StudentsStoreScreen = () => {
    const [data, setData] = useState({
        loaded: false,
        budget: 0,
        maxPerDay: 0,
        minCharge: 0,
        pass: '',
    });
    const [storeFilters, setStoreFilters] = useState({
        shown: '' as '' | 'filters' | 'time'
    });
    const [timeForStore, setTimeForStore] = useState<DayRange>({from: null, to: null});
    const [storeList, setStoreList] = useState([] as pointTransactionSingleInterface[]);
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/parents/store/overview',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                budget: number,
                maxPerDay: number,
                minCharge: number,
                pass: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                setData({
                    loaded: true,
                    maxPerDay: d.maxPerDay,
                    minCharge: d.minCharge,
                    budget: d.budget,
                    pass: d.pass,
                });
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    const fetchStoreList = () => {
        setStoreFilters({shown: ''});
        const t = {...timeForStore};
        let fromString = '';
        let toString = '';
        if (t.from !== null && t.to !== null && typeof t.from !== 'undefined' && typeof t.to !== 'undefined') {
            const g = PersianToGregorian(`${t.from.year}-${t.from.month}-${t.from.day}`);
            const g2 = PersianToGregorian(`${t.to.year}-${t.to.month}-${t.to.day}`);
            fromString = g;
            toString = g2;
        } else {
            const today = new Date();
            const priorDate = new Date(new Date().setDate(today.getDate() - 30));
            const todayIso = today.toISOString().split('T')[0].split('-');
            const priorIso = priorDate.toISOString().split('T')[0].split('-');
            let from = {
                year: parseInt(priorIso[0]),
                month: parseInt(priorIso[1]),
                day: parseInt(priorIso[2]),
            };
            let to = {
                year: parseInt(todayIso[0]),
                month: parseInt(todayIso[1]),
                day: parseInt(todayIso[2]),
            };
            const g1 = GregorianToPersian(priorDate).split('-');
            from = {
                year: parseInt(g1[0]),
                month: parseInt(g1[1]),
                day: parseInt(g1[2]),
            };
            const g2 = GregorianToPersian(today).split('-');
            to = {
                year: parseInt(g2[0]),
                month: parseInt(g2[1]),
                day: parseInt(g2[2]),
            };
            const fromMonth = from.month < 10 ? `0${from.month}` : from.month;
            const fromDay = from.day < 10 ? `0${from.day}` : from.day;
            let g = `${from.year}-${fromMonth}-${fromDay}`;
            const toMonth = to.month < 10 ? `0${to.month}` : to.month;
            const toDay = to.day < 10 ? `0${to.day}` : to.day;
            fromString = PersianToGregorian(`${from.year}-${from.month}-${from.day}`);
            toString = PersianToGregorian(`${to.year}-${to.month}-${to.day}`);
            setTimeForStore({
                from: from,
                to: to,
            });
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + "/core/parents/store/history",
            {
                f: fromString,
                t: toString,
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: pointTransactionSingleInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                setStoreList(d.list === null ? [] : d.list);
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "فروشگاه | نهال";
        fetchData();
        fetchStoreList();
    }, []);
    const [increaseModal, setIncreaseModal] = useState(false);
    const [editMaxModal, setEditMaxModalModal] = useState(false);
    const [passModal, setPassModal] = useState(false);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'پنل دانش‌آموزان', url: '/students/'},
                {title: 'فروشگاه', url: '/students/store'},
            ]}/>
            {
                data.loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="row justify-content-center">
                            <div className="col-lg-6">
                                <div className="screen-card">
                                    <div className="screen-card-header">
                                        <b>حساب بوفه</b>
                                    </div>
                                    <div className="person-account-balance">
                                        <div className="person-account-balance-main">
                                            <span>{CurrencyFormat(data.budget)}</span>
                                            <TomansIcon/>
                                        </div>
                                        <div className="d-block"/>
                                        <button className="person-account-balance-increase"
                                                onClick={() => {
                                                    // ShowSnackbar(
                                                    //     'این امکان هنوز فعال نشده است.',
                                                    //     'باشه',
                                                    //     5000,
                                                    // );
                                                    setIncreaseModal(true)
                                                }}>
                                            <i><ThickAddIcon/></i>
                                            <span>افزایش اعتبار</span>
                                        </button>
                                        <hr/>
                                        <button className="normal-list-tile" onClick={() => setEditMaxModalModal(true)}>
                                            <div>
                                                <i><ThinCreditCardTimeIcon/></i>
                                                <div>
                                                    <b>محدودیت خرید روزانه</b>
                                                    <span>تعیین سقف برداشت روزانه بوفه.</span>
                                                </div>
                                            </div>
                                            <ThinChevronRight/>
                                        </button>
                                        <button className="normal-list-tile" onClick={() => setPassModal(true)}>
                                            <div>
                                                <i><ThinPasswordIcon/></i>
                                                <div>
                                                    <b>تغییر رمز کارت</b>
                                                    <span>گذرواژه ۴ رقمی هنگام خرید از بوفه.</span>
                                                </div>
                                            </div>
                                            <ThinChevronRight/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="screen-card">
                                    <div className="screen-card-header">
                                        <b>تراکنش‌های فروشگاه</b>
                                        <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
                                            <div className="filter-buttons">
                                                <ClickOutsideDetector
                                                    onClickOutside={() => {
                                                        setStoreFilters(v => {
                                                            let x = {...v};
                                                            x.shown = '';
                                                            return x;
                                                        });
                                                    }}
                                                    className={"filter-button-c" + (storeFilters.shown === 'time' ? ' active' : '')}>
                                                    <button onClick={(e) => {
                                                        e.stopPropagation();
                                                        setStoreFilters(v => {
                                                            let x = {...v};
                                                            x.shown = x.shown === 'time' ? '' : 'time';
                                                            return x;
                                                        });
                                                    }}>
                                                        <ThinTimeIcon/>
                                                        <span>زمان</span>
                                                        <ThinCaretDownIcon/>
                                                    </button>
                                                    {
                                                        storeFilters.shown === 'time' ?
                                                            <div>
                                                                <label className="f-roboto">لطفا یک بازه
                                                                    زمانی را انتخاب
                                                                    کنید:</label>
                                                                <Calendar
                                                                    value={timeForStore}
                                                                    onChange={e => setTimeForStore(e)}
                                                                    shouldHighlightWeekends
                                                                    colorPrimary='#0a53be'
                                                                    locale={'fa'}
                                                                />
                                                                <div className="text-end">
                                                                    <button
                                                                        className="filter-button-cta"
                                                                        onClick={fetchStoreList}>
                                                                        <span>اعمال تغییرات</span>
                                                                    </button>
                                                                </div>
                                                            </div> :
                                                            null
                                                    }
                                                </ClickOutsideDetector>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        storeList.length === 0 ?
                                            <div className="staff--not-found">
                                                <em style={{backgroundImage: 'url(/svg/store.svg)'}}/>
                                                <b>گزارشی یافت نشد</b>
                                                <p>در بازه زمانی انتخاب شده، گزارشی یافت نشد.</p>
                                            </div> :
                                            null
                                    }
                                    {
                                        storeList.length > 0 ?
                                            <table
                                                className="table open-table table-bordered table-hover">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>نوع</th>
                                                    <th>مبلغ</th>
                                                    <th>پرداخت</th>
                                                    <th>تاریخ</th>
                                                    <th>زمان</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    storeList.map((r, i) =>
                                                        <tr key={"Jd932uf8" + i}>
                                                            <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                                            <td>{pointTransactionSourceToString(r.source)}</td>
                                                            <td>
                                                                <span
                                                                    style={{
                                                                        fontWeight: 400,
                                                                        color: r.price < 0 ? '#8b0000' : 'darkgreen'
                                                                    }}>
                                                                    {CurrencyFormat(r.price.toString().replace('-', '')) + (r.price < 0 ? '-' : '+')}
                                                                    <TomansIcon/>
                                                                </span>
                                                            </td>
                                                            <td>{pointTransactionPayMethodToString(r.method)}</td>
                                                            <td>{StringDigitsConvertToPersian(GregorianToPersian(r.createdAt).replaceAll('-', '/'))}</td>
                                                            <td>{StringDigitsConvertToPersian(r.createdAt.split(' ')[1])}</td>
                                                        </tr>
                                                    )
                                                }
                                                </tbody>
                                            </table> : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div> : null
            }
            <ParentsMaxPayPerDayEditModal
                active={editMaxModal}
                closeHandler={() => setEditMaxModalModal(false)}
                onDone={() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                    ShowProgressLoading();
                    fetchData();
                }}
                currentMax={data.maxPerDay}
            />
            <StudentsSetCardPasswordModal
                active={passModal}
                closeHandler={() => setPassModal(false)}
                onDone={(p: string) => {
                    const r = p;
                    setData(v => {
                        let x = {...v};
                        x.pass = r;
                        return x;
                    });
                }}
                pass={data.pass}
            />
            <StudentsIncreaseStoreBudgetModal
                active={increaseModal}
                closeHandler={()=>setIncreaseModal(false)}
                min={data.minCharge}
            />
        </>
    );
};